module.exports = __webpack_public_path__ + "media/fonts/calibri/Calibri-Regular-5d7c31b284ddb01fc1cbae0edc9ec210.ttf";